import { render, staticRenderFns } from "./AuthorityDistributeRoute.vue?vue&type=template&id=c2c1013c"
import script from "./AuthorityDistributeRoute.vue?vue&type=script&lang=js"
export * from "./AuthorityDistributeRoute.vue?vue&type=script&lang=js"
import style0 from "./AuthorityDistributeRoute.vue?vue&type=style&index=0&id=c2c1013c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports